import { FinallyImportResponse } from "types/Models/books";
import { emptyApi } from "./emptyApi";

const extendedApi = emptyApi.injectEndpoints({
  endpoints: (build) => ({
    uploadFinallyFiles: build.mutation<
      FinallyImportResponse,
      {
        entityId: string;
        payload: {
          coa_file: File;
          je_files: File[];
          date_till_import: string;
          prev_fy_end_date: string;
        };
      }
    >({
      query: ({ entityId, payload }) => {
        const { coa_file, je_files, date_till_import, prev_fy_end_date } =
          payload;
        const formData = new FormData();

        formData.append("prev_fy_end_date", prev_fy_end_date);
        formData.append("date_till_import", date_till_import);
        formData.append("coa_file", coa_file);
        je_files.forEach((file) => formData.append("je_file", file));

        return {
          url: `/api/inkle/bookkeeping/entity/${entityId}/finally_import/`,
          method: "POST",
          body: formData,
        };
      },
    }),

    getFinallyImport: build.query<
      FinallyImportResponse,
      { entityId: string; review?: boolean }
    >({
      query: ({ entityId, review }) => ({
        url: `/api/inkle/bookkeeping/entity/${entityId}/finally_import/`,
        method: "GET",
        params: review ? { review: true } : undefined,
      }),
      providesTags: ["CHART_OF_ACCOUNTS"],
    }),

    finalizeFinallyImport: build.mutation<void, { entityId: string }>({
      query: ({ entityId }) => ({
        url: `/api/inkle/bookkeeping/entity/${entityId}/finally_import/`,
        method: "PATCH",
      }),
      invalidatesTags: ["CHART_OF_ACCOUNTS"],
    }),

    revertFinallyImport: build.mutation<
      FinallyImportResponse,
      { entityId: string }
    >({
      query: ({ entityId }) => ({
        url: `/api/inkle/bookkeeping/entity/${entityId}/finally_import/`,
        method: "DELETE",
      }),
      async onQueryStarted({ entityId }, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(
            extendedApi.util.updateQueryData(
              "getFinallyImport",
              { entityId },
              () => data
            )
          );
        } catch {
          // The caller surfaces the error through unwrap()
        }
      },
    }),
  }),
});

export const {
  useUploadFinallyFilesMutation,
  useGetFinallyImportQuery,
  useFinalizeFinallyImportMutation,
  useRevertFinallyImportMutation,
} = extendedApi;
